import { useEffect } from 'react';
import { useQuery } from 'urql';
import PageHeader from '../../../components/PageHeader.jsx';
import StickyActions from '../../../components/StickyActions.jsx';
import { GET_INGRESO } from './gql.js';

export default function RecepcionDetail({ ingresoId, onBack }) {
  const [{ data, fetching, error }, reexecute] = useQuery({ query: GET_INGRESO, variables: { id: ingresoId } });

  useEffect(() => {
    reexecute({ requestPolicy: 'network-only' });
  }, [ingresoId, reexecute]);

  const ingreso = data?.getIngresoStock;

  return (
    <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-6 px-6 py-8">
      <PageHeader
        title={`Ingreso #${ingreso?.id ?? ''}`}
        subtitle="Detalle del ingreso y productos actualizados."
      />

      <section className="rounded-2xl border border-[rgb(var(--border))] bg-[rgba(var(--panel),0.7)] p-6 shadow-sm">
        {fetching ? (
          <p className="text-sm text-muted">Cargando ingreso…</p>
        ) : error ? (
          <p className="text-sm text-red-300">{error.message}</p>
        ) : ingreso ? (
          <div className="space-y-6">
            <dl className="grid grid-cols-12 gap-4 text-sm text-[rgb(var(--fg))]">
              <div className="col-span-12 md:col-span-4">
                <dt className="font-medium text-muted">Fecha</dt>
                <dd className="mt-1">{ingreso.fecha ? new Date(ingreso.fecha).toLocaleString() : '—'}</dd>
              </div>
              <div className="col-span-12 md:col-span-4">
                <dt className="font-medium text-muted">Tipo</dt>
                <dd className="mt-1">{ingreso.tipo}</dd>
              </div>
              <div className="col-span-12 md:col-span-4">
                <dt className="font-medium text-muted">Usuario</dt>
                <dd className="mt-1">{ingreso.usuario || '—'}</dd>
              </div>
              <div className="col-span-12">
                <dt className="font-medium text-muted">Observación</dt>
                <dd className="mt-1 whitespace-pre-line">{ingreso.observacion || '—'}</dd>
              </div>
            </dl>

            <div className="overflow-hidden rounded-2xl border border-[rgb(var(--border))] bg-[rgba(var(--bg),0.6)]">
              <table className="w-full text-left text-sm">
                <thead className="bg-[rgba(var(--subpanel),0.4)] text-xs uppercase tracking-wide text-muted">
                  <tr>
                    <th className="px-4 py-3">Descripción</th>
                    <th className="px-4 py-3">Cantidad</th>
                    <th className="px-4 py-3">Costo unitario</th>
                    <th className="px-4 py-3">Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  {ingreso.items?.length ? (
                    ingreso.items.map((item) => (
                      <tr key={item.id} className="border-t border-[rgb(var(--border))]/60">
                        <td className="px-4 py-3">{item.descripcion || `#${item.productoId}`}</td>
                        <td className="px-4 py-3">{Number(item.cantidad).toLocaleString()}</td>
                        <td className="px-4 py-3">{Number(item.costoUnit).toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</td>
                        <td className="px-4 py-3">{Number(item.subtotal).toLocaleString('es-AR', { style: 'currency', currency: 'ARS' })}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="px-4 py-6 text-center text-sm text-muted">
                        Sin ítems cargados.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <p className="text-sm text-muted">No encontramos el ingreso solicitado.</p>
        )}
      </section>

      <StickyActions
        left={
          <button
            type="button"
            onClick={onBack}
            className="rounded-xl border border-[rgb(var(--border))] bg-transparent px-4 py-2 text-sm font-medium text-[rgb(var(--fg))] transition hover:bg-[rgba(var(--fg),0.05)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
          >
            Volver
          </button>
        }
        right={null}
      />
    </div>
  );
}
